module.exports = __webpack_public_path__ + "static/media/training-animations.be529bcf.svg";